import { render, staticRenderFns } from "./RequireAddress.vue?vue&type=template&id=b73d82e8&scoped=true&"
import script from "./RequireAddress.vue?vue&type=script&lang=js&"
export * from "./RequireAddress.vue?vue&type=script&lang=js&"
import style0 from "./RequireAddress.vue?vue&type=style&index=0&id=b73d82e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73d82e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b73d82e8')) {
      api.createRecord('b73d82e8', component.options)
    } else {
      api.reload('b73d82e8', component.options)
    }
    module.hot.accept("./RequireAddress.vue?vue&type=template&id=b73d82e8&scoped=true&", function () {
      api.rerender('b73d82e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prize/pool/components/RequireAddress.vue"
export default component.exports